export default __webpack_public_path__ + "static/media/user-main.66aa70fa.jpg";